import { jsxs, jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const PanoramaIcon = (props)=>/*#__PURE__*/ jsxs("svg", _objectSpreadProps(_objectSpread({}, props), {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M6.84533 3.33341C6.93224 3.48627 7.04853 3.62043 7.1875 3.72816C7.32647 3.8359 7.48538 3.91508 7.65508 3.96116C7.82477 4.00723 8.00191 4.01928 8.17628 3.99661C8.35066 3.97395 8.51882 3.91702 8.6711 3.82909C8.82339 3.74117 8.95677 3.624 9.06358 3.48431C9.17039 3.34463 9.24852 3.1852 9.29347 3.0152C9.33841 2.8452 9.34929 2.66799 9.32547 2.49378C9.30164 2.31956 9.2436 2.15177 9.15467 2.00008C8.9766 1.69633 8.68562 1.47535 8.34523 1.38536C8.00483 1.29536 7.64266 1.34366 7.33774 1.51971C7.03283 1.69576 6.80992 1.98527 6.71767 2.32506C6.62542 2.66485 6.67131 3.02733 6.84533 3.33341ZM8.04133 8.74674L8.28133 11.1414V11.1407L9.04467 11.5227C9.07516 11.5378 9.10901 11.5449 9.14299 11.5432C9.17697 11.5416 9.20998 11.5313 9.23888 11.5134C9.26778 11.4954 9.29162 11.4704 9.30815 11.4406C9.32468 11.4109 9.33334 11.3774 9.33333 11.3434V8.54008C9.33352 8.47827 9.35089 8.41773 9.3835 8.36522C9.41611 8.31271 9.46268 8.27031 9.518 8.24274L9.81533 8.09274C9.87066 8.06518 9.91722 8.02277 9.94983 7.97026C9.98244 7.91776 9.99981 7.85722 10 7.79541V6.05541C10.0001 5.84539 9.93411 5.64066 9.81134 5.47026C9.68857 5.29986 9.51526 5.17244 9.316 5.10608L6.878 4.29341C6.77769 4.25988 6.67083 4.2507 6.56627 4.26663C6.46171 4.28256 6.36244 4.32313 6.27665 4.38501C6.19087 4.44689 6.12105 4.52829 6.07294 4.62248C6.02484 4.71668 5.99983 4.82097 6 4.92674V6.53008C6.0002 6.61841 6.03544 6.70305 6.098 6.76541L6.56867 7.23674C6.63122 7.2991 6.66647 7.38374 6.66667 7.47208V10.1287C6.66673 10.1907 6.68404 10.2513 6.71666 10.304C6.74928 10.3566 6.79591 10.3991 6.85133 10.4267L7.46667 10.7347L7.90933 8.74074C7.91227 8.72485 7.92088 8.71057 7.93356 8.70055C7.94623 8.69053 7.96212 8.68546 7.97825 8.68628C7.99439 8.68709 8.00968 8.69374 8.02129 8.70498C8.03289 8.71623 8.04001 8.73131 8.04133 8.74741V8.74674Z",
                fill: props.fill
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M2.66659 10.6668C2.66659 10.0974 3.69792 9.5321 5.33325 9.2281V7.86743C2.93725 8.26077 1.33325 9.2221 1.33325 10.6674C1.33325 12.1341 2.95925 13.0908 5.42259 13.4768L5.33392 14.5128C5.32976 14.549 5.34002 14.5853 5.36248 14.614C5.38494 14.6427 5.41778 14.6614 5.45392 14.6661C5.47641 14.6686 5.49918 14.6652 5.51992 14.6561L8.91858 13.2814C8.95161 13.2658 8.97731 13.238 8.99035 13.2038C9.00339 13.1697 9.00276 13.1318 8.98858 13.0981C8.97786 13.0705 8.95844 13.0471 8.93325 13.0314L5.82658 11.0194C5.81135 11.0102 5.79438 11.0041 5.77671 11.0016C5.75904 10.9991 5.74105 11.0002 5.72383 11.0049C5.70661 11.0095 5.69053 11.0177 5.67656 11.0288C5.66259 11.0399 5.65103 11.0537 5.64258 11.0694C5.63319 11.087 5.62752 11.1063 5.62592 11.1261L5.53858 12.1421C3.75325 11.8434 2.66659 11.2368 2.66659 10.6668ZM10.6666 9.2281V7.86743C13.0646 8.26077 14.6666 9.22543 14.6666 10.6761C14.6666 12.1094 13.1393 13.0361 10.7733 13.4454C10.6013 13.4705 10.4264 13.4275 10.2857 13.3255C10.1451 13.2235 10.0498 13.0707 10.0201 12.8995C9.99049 12.7283 10.0289 12.5522 10.1271 12.4089C10.2253 12.2656 10.3756 12.1663 10.5459 12.1321C12.3333 11.8221 13.3333 11.2154 13.3333 10.6761C13.3333 10.1008 12.3039 9.53277 10.6666 9.2281Z",
                fill: props.fill
            })
        ]
    }));
PanoramaIcon.defaultProps = {
    width: 16,
    height: 16,
    fill: 'currentColor'
};

export { PanoramaIcon as default };
//# sourceMappingURL=Panorama.mjs.map
